/**
 * Module dependencies.
 */

import { Button, TextField, Typography } from '@mui/material';
import styled from '@emotion/styled';

/**
 * Export `Paragraph` styled component.
 */

export const Paragraph = styled(Typography)``;

/**
 * Export `Form` styled component.
 */

export const Form = styled.form`
  display: flex;
  gap: 8px;
  width: 100%;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

/**
 * Export `EmailInput` styled component.
 */

export const EmailInput = styled(TextField)`
  flex-grow: 1;
  background: white;
  border-radius: 4px 0 0 4px;
  font-size: 12px;

  & .MuiInputBase-input::placeholder {
    font-size: 14px;
    color: #333;
  }

  & .MuiInputBase-input {
    font-size: 14px;
    color: #333;
  }
`;

/**
 * Export `SubscribeButton` styled component.
 */

export const SubscribeButton = styled(Button)``;
